/* eslint-disable no-use-before-define */
/* eslint-disable comma-spacing */
import React from 'react';
import useInfiniteScroll from './PaginationScroll';
import { translate } from '../../utils/util';

const ListPaginationUl = (props) => {
    const [,] = useInfiniteScroll(fetchMoreListItems, props);
    let aux = 0;
    function fetchMoreListItems() {
        const current = props.current.currentPage + 1;
        props.current.setCurrentPage(current);
    }

    return (
        <>
            {props.disableRow ? props.data :
                <div className="row" style={{ marginBottom: '0px' }}>
                    <ul className="col s12" style={{ padding: '0', marginTop: '0' }}>
                        {
                            props.data.map((item) => (
                                <li
                                    key={`oi-${aux += 1}`}
                                    style={{ backgroundColor: 'white', boxShadow: '0 1px 5px 0 rgba(0,0,0,0.2)', padding: '4px' }}
                                >
                                    {
                                        item
                                    }
                                </li>
                            ))
                        }
                        {
                            props.page !== undefined && props.data.length === 0 && (
                                <div className="container-fluid h-65" style={{ textAlign: 'center' }}>
                                    {translate('general:no-registry')}
                                </div>)
                        }

                    </ul>
                </div>}
            <div id="paginationUlInfiniteScroll" />
        </>
    );
};

export default ListPaginationUl;
